import React from 'react'
import { FlatSkeleton } from '@components/admin/flat-skeleton'

export const NotAuthorized: React.FC = () => {
  return (
    <FlatSkeleton>
      <p>Voce não possui permissão de acesso a esta tela</p>
    </FlatSkeleton>
  )
}
